import { jwtDecode } from "jwt-decode";

export const checkTokenIsExpired = (token) =>
	new Promise((resolve) => {
		try {
			const { exp } = jwtDecode(token);
			const current = (new Date().getTime() + 1) / 1000;
			// jeżeli token wygasł
			if (Math.floor(exp - current) <= 0) {
				return resolve(true);
			}
		} catch (err) {
			resolve(false);
		}

		resolve(false);
	});
